/* unplugin-vue-components disabled */import script from "./indexOrganize.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexOrganize.vue?vue&type=script&lang=ts&setup=true"

import "./indexOrganize.vue?vue&type=style&index=0&id=24739f9c&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24739f9c"]])

export default __exports__